import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38cc34e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "box box-1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 올바른"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 종이팩 분리배출법 ")
], -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"box box-2\" data-v-38cc34e5><h4 class=\"title\" data-v-38cc34e5><span data-v-38cc34e5>종이팩?</span><span data-v-38cc34e5> 일반팩? 멸균팩?</span><br class=\"d-block d-md-none\" data-v-38cc34e5><span data-v-38cc34e5>차이점 바로알기!</span></h4><div class=\"desc\" data-v-38cc34e5><div class=\"desc-row\" data-v-38cc34e5><div class=\"name\" data-v-38cc34e5> - 종이팩 :  </div><div class=\"d-block d-md-none content\" data-v-38cc34e5><p data-v-38cc34e5>종이팩은 일반팩과 멸균팩을 모두 포함하는</p><p data-v-38cc34e5>큰 개념으로, 다양한 제품을 담을 수 있도록</p><p data-v-38cc34e5>만든 종이용기인 만큼 우수한 펄프로 만들어져</p><p data-v-38cc34e5>재활용 가치가 아주 높습니다.</p></div><div class=\"d-none d-md-block content\" data-v-38cc34e5><p data-v-38cc34e5>종이팩은 일반팩과 멸균팩을 모두 포함하는 큰 개념으로,</p><p data-v-38cc34e5>다양한 제품을 담을 수 있도록 만든 종이용기인 만큼</p><p data-v-38cc34e5>우수한 펄프로 만들어져 재활용 가치가 아주 높습니다.</p></div></div><div class=\"desc-row\" data-v-38cc34e5><div class=\"name\" data-v-38cc34e5> - 일반팩 :  </div><div class=\"content\" data-v-38cc34e5><p data-v-38cc34e5>주로 냉장보관이 필요한 제품을 보관하는데 사용해요.<br class=\"d-block d-md-none\" data-v-38cc34e5> (우유, 주스)</p></div></div><div class=\"desc-row\" data-v-38cc34e5><div class=\"name\" data-v-38cc34e5> - 멸균팩 :  </div><div class=\"content\" data-v-38cc34e5><p data-v-38cc34e5>주로 상온보관이 가능한 제품을 보관하는데 사용해요.<br class=\"d-block d-md-none\" data-v-38cc34e5> (두유, 멸균유)</p></div></div></div></div><div class=\"box box-3\" data-v-38cc34e5><h4 class=\"title\" data-v-38cc34e5> 이렇게 구분해요! </h4><div class=\"desc\" data-v-38cc34e5><div class=\"desc-row\" data-v-38cc34e5><div class=\"content\" data-v-38cc34e5><p data-v-38cc34e5>1) 제품 겉면 재활용 마크를 통해 확인 가능 (일반팩 ,멸균팩)</p><p data-v-38cc34e5>2) 종이팩의 내부가 흰색 종이면 일반팩, 알루미늄 호일이면 멸균팩</p></div></div></div></div>", 2)

import ImageMobile from '../images/page-4/mobile.png';
import ImagePc from '../images/page-4/pc.png';
import ImageChild from '../images/page-4/child.png';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(ImageChild),
      class: "img-child"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("img", {
        src: _unref(ImageMobile),
        class: "d-inline-block d-md-none image"
      }, null, 8, _hoisted_5),
      _createElementVNode("img", {
        src: _unref(ImagePc),
        class: "d-none d-md-inline-block image"
      }, null, 8, _hoisted_6)
    ]),
    _hoisted_7
  ]))
}
}

})